import { resolveText } from '@/utils/textValue';

export const resolvePersonDisplayName = (person) => {
  const directName = resolveText(person?.name || person?.label || '');
  if (directName !== '') {
    return directName;
  }

  const firstName = resolveText(person?.first_name || person?.firstName || '');
  const lastName = resolveText(person?.last_name || person?.lastName || '');
  return `${firstName} ${lastName}`.trim();
};

export const formatRecipientLabel = (name = '', email = '') => {
  const normalizedName = resolveText(name, '');
  const normalizedEmail = resolveText(email, '').toLowerCase();

  if (normalizedName !== '' && normalizedEmail !== '') {
    return `${normalizedName} <${normalizedEmail}>`;
  }

  if (normalizedEmail !== '') {
    return normalizedEmail;
  }

  return normalizedName;
};

export const normalizeRecipientOption = (item, index = 0, prefix = 'recipient') => {
  if (item === null || item === undefined) {
    return null;
  }

  if (typeof item === 'string' || typeof item === 'number') {
    const rawValue = resolveText(item, '');
    if (rawValue === '') {
      return null;
    }

    const email = rawValue.includes('@') ? rawValue.toLowerCase() : '';
    const name = email !== '' ? email : rawValue;

    return {
      id: `${prefix}-${index}-${name}`,
      name,
      email,
      label: formatRecipientLabel(name, email),
      invoice_mailing: 0,
      payments_mailing: 0,
    };
  }

  if (typeof item !== 'object') {
    return null;
  }

  const name = resolvePersonDisplayName(item);
  const email = resolveText(item?.email || item?.mail || '', '').toLowerCase();
  if (name === '' && email === '') {
    return null;
  }

  const resolvedName = name !== '' ? name : email;
  const id = resolveText(
    item?.id
      || item?.person_id
      || item?.value
      || item?.collaborator_id
      || email,
    `${prefix}-${index}`
  );

  return {
    id,
    name: resolvedName,
    email,
    label: formatRecipientLabel(resolvedName, email),
    invoice_mailing: Number(item?.invoice_mailing || item?.invoiceMailing || 0),
    payments_mailing: Number(item?.payments_mailing || item?.paymentsMailing || 0),
  };
};

export const uniqueRecipientsByKey = (items = []) => {
  const seen = new Set();

  return (Array.isArray(items) ? items : []).filter((item) => {
    if (!item || typeof item !== 'object') {
      return false;
    }

    const dedupeKey = String(item.email || item.id || '').trim().toLowerCase();
    if (dedupeKey === '' || seen.has(dedupeKey)) {
      return false;
    }

    seen.add(dedupeKey);
    return true;
  });
};
